/**
 * MobileDrawer
 * 
 * Mobile/tablet sidebar drawer using React Bootstrap Offcanvas.
 * Provides accessibility, focus management, and animations out of the box.
 * React 19 compatible - uses native callback refs.
 */

import { Offcanvas } from 'react-bootstrap';
import './MobileDrawer.scss';

export const MobileDrawer = ({ children, open, onOpenChange }) => {
  return (
    <Offcanvas
      show={open}
      onHide={() => onOpenChange(false)}
      placement="start"
      className="mobile-drawer-offcanvas"
      aria-labelledby="mobile-drawer-title"
      data-testid="mobile-drawer"
    >
      <Offcanvas.Header className="mobile-drawer-header">
        <Offcanvas.Title id="mobile-drawer-title" className="visually-hidden">
          Navigation Menu
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="mobile-drawer-body">
        {children}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

